var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgIconNotice48Line = function SvgIconNotice48Line(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "current",
    height: "current",
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M38.7 22.71c0-3.46-2.63-6.31-6-6.66v-3.98c0-1.1-.61-2.09-1.58-2.58-.98-.5-2.14-.41-3.02.24l-8.65 6.29H14.6a5.31 5.31 0 0 0-5.3 5.3v2.8c0 2.82 2.22 5.11 5 5.27v7.62h3.4v-7.59h1.75l8.65 6.29c.51.37 1.1.56 1.7.56.45 0 .9-.1 1.32-.32.98-.5 1.58-1.49 1.58-2.58v-3.98c3.37-.35 6-3.21 6-6.66v-.02Zm-9.4 9.66L21 26.33c-.29-.21-.64-.33-1-.33h-5.4a1.9 1.9 0 0 1-1.9-1.9v-2.8c0-1.05.85-1.9 1.9-1.9H20c.36 0 .71-.11 1-.33l8.3-6.04v19.34Zm3.4-6.44v-6.45c1.48.32 2.6 1.65 2.6 3.23s-1.12 2.9-2.6 3.23v-.01Z",
    fill: "current"
  })));
};
export default SvgIconNotice48Line;